export const buildURLQueryNoNulls = obj => {
    if (obj) {
      let entries = Object.entries(obj);
      let filtered = entries.filter(e => e[1]);
      return filtered.map(pair => pair.map(encodeURIComponent).join("=")).join("&");
    }
    return "";
  }